import { AxiosPromise } from 'axios';

import {
  IPublishSettings, ISettingsBase, ICreateablePublishSettings, IUpdateablePublishSettings,
} from './interfaces';
import { IUser as IIdmUser } from '../../idm/interfaces';
import { vaultApi } from '../api';

import { IApiResponse } from '../interfaces';

const basePath = '/publish/settings';
const idPath = (id: string) => `${basePath}/${id}`;
const resendConsentPath = (id: string) => `${idPath(id)}/resendConsentForm`;

export const createPublishSettings = <T extends ISettingsBase>(settings: ICreateablePublishSettings<T>): AxiosPromise<any> => vaultApi.getInstance().post(basePath, settings);

export const getAllPublishSettings = <T extends ISettingsBase>(impersonatedUser?: IIdmUser): AxiosPromise<IApiResponse<IPublishSettings<T>[]>> => vaultApi.getInstance().get(
  basePath,
  {
    params: impersonatedUser
      ? { impersonatedUserId: impersonatedUser.id }
      : {},
  },
);

export const deleteSettings = (id: string): AxiosPromise<any> => vaultApi.getInstance().delete(idPath(id));

export const updateSettings = <T extends ISettingsBase>(id: string, settings: IUpdateablePublishSettings<T>): AxiosPromise<any> => vaultApi.getInstance().put(idPath(id), settings);

export const resendPublishConsentEmail = (id: string): AxiosPromise<any> => vaultApi.getInstance().post(resendConsentPath(id));
